import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";

export default function ServerError() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [showLottie, setShowLottie] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLottie(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleRetry = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        textAlign: "center",
        background: "linear-gradient(180deg, #ffffff, #f8fafc)",
        px: 3,
      }}
    >
      <Typography
        variant="h4"
        fontWeight={800}
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark || theme.palette.primary.main})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Server Error
      </Typography>

      <Typography
        color="text.secondary"
        fontSize={14}
        sx={{ maxWidth: 380 }}
      >
        Something went wrong on our end. The server encountered an unexpected
        error. Please try again.
      </Typography>

      <Box
        sx={{
          width: 320,
          maxWidth: "90%",
          height: showLottie ? 320 : 0,
          opacity: showLottie ? 1 : 0,
          transition: "opacity 0.5s ease, height 0.5s ease",
          overflow: "hidden",
        }}
      >
        {showLottie && (
          <iframe
            src="https://lottie.host/embed/d368c11d-d975-41cb-bc04-989dcbd2efd4/lC1o98uvZ1.lottie"
            style={{ width: "100%", height: "100%", border: "none" }}
            title="500 Animation"
          />
        )}
      </Box>

      <Stack direction="row" spacing={2} sx={{ mt: 1.5 }}>
        <Button
          variant="contained"
          size="large"
          sx={{ borderRadius: 2, px: 4 }}
          onClick={handleRetry}
        >
          Go Back
        </Button>
        <Button
          variant="outlined"
          size="large"
          sx={{ borderRadius: 2, px: 4 }}
          onClick={() => navigate("/")}
        >
          Go Home
        </Button>
      </Stack>
    </Box>
  );
}
